import { DropTargetMonitor } from "react-dnd";

export const canDrop = (uploadId: number) => (item: unknown, monitor: DropTargetMonitor<unknown, unknown>) => {
  const overSelf = item != null && typeof item === "object" && "uploadId" in item && item.uploadId === uploadId;
  return !overSelf && monitor.getItemType() === "scan";
};

export const ROW_HEIGHT = 52;
